"use client";
import "./hero.scss";
import { useBlock, useAttr } from "@/core/blocks/context";
import { Heading, TextAttr, VideoAttr, LinkAttr } from "@/core/blocks/attributes";
import { lv } from "@/core/i18n";
import type { LinkValue, Localized } from "@/core/types";

function HeroButton({ name, labelName, className }: { name: string; labelName: string; className: string }) {
  const ctx = useBlock();
  const [link] = useAttr<LinkValue | null>(name);
  const [label] = useAttr<Localized>(labelName);
  if (!ctx.editing && (!link?.href || !lv(label, ctx.locale))) return null;
  return (
    <LinkAttr name={name} className={className}>
      <TextAttr name={labelName} placeholder={{ nl: "Knoptekst", en: "Button text" }} />
    </LinkAttr>
  );
}

export default function HeroBlock() {
  return (
    <section className="block-hero">
      <VideoAttr name="video" className="hero-video" />
      <div className="hero-overlay" />
      <div className="container hero-content">
        <Heading name="title" className="hero-title" placeholder={{ nl: "Grote titel", en: "Big title" }} />
        <TextAttr name="description" rich as="p" className="hero-description" placeholder={{ nl: "Korte beschrijving…", en: "Short description…" }} />
        <div className="hero-actions">
          <HeroButton name="cta1" labelName="cta1Label" className="btn btn-primary" />
          <HeroButton name="cta2" labelName="cta2Label" className="btn btn-ghost" />
        </div>
      </div>
    </section>
  );
}

export const meta = { label: "Hero (video)", icon: "smart_display" };

export function defaults(): Record<string, unknown> {
  return {
    title: { nl: "Welkom" },
    description: { nl: "" },
  };
}
